import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, orangeMui } from "@ryde/theme";

export const RideAddPassengerFormStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "ride-add-passenger-form",
})`
  margin-top: 15px;
  border-radius: 6px;
  padding: 15px;
  border: 1px solid ${greyMui._200};
  display: flex;
  flex-direction: column;
  gap: 20px;

  .passenger_container {
    display: grid;
    grid-template-columns: 1fr 75px 40px 40px;
    align-items: center;

    .ride-add-passenger__seats {
      padding-inline-start: 4px;

      input[type="number"] {
        padding: 11px 14px;
      }
    }
  }
  .stations_container {
    display: grid;
    grid-template-columns: 1fr 40px 55px 1fr 40px 40px;
    align-items: center;
  }

  .add-passenger-view-switch {
    padding-inline: 20px;

    h3 {
      padding-top: 12px;
      padding-bottom: 10px;
      font-size: 14px;
    }
    .view-options-container {
      .MuiTypography-root {
        font-size: 14px;
      }
    }
  }

  .add-passengers__form-actions {
    display: flex;
    gap: 10px;
    margin-inline-start: auto;
  }

  .passenger-from-other-site__icon {
    color: ${orangeMui._600};
    margin-inline: 6px;
  }
`;
